import { useEffect, useState } from 'react';
import { useAuth } from '@/contexts/AuthContext';
import { workflowService, ProgramStatusAuditLog } from '@/services/features/WorkflowService';

export const useProgramTypeAuditLog = (programTypeId: number | null) => {
  const [programTypeAuditLogs, setProgramTypeAuditLogs] = useState<ProgramStatusAuditLog[]>([]);
  const [auditLogsLoading, setAuditLogsLoading] = useState(false);
  const { hasuraToken } = useAuth();

  useEffect(() => {
    const fetchAuditLogs = async () => {
      if (!programTypeId || !hasuraToken) return;

      setAuditLogsLoading(true);
      try {
        const result = await workflowService.getProgramTypeAuditLog(hasuraToken, programTypeId);
        setProgramTypeAuditLogs(result.logs);
      } catch (error) {
        console.error('Error fetching program type audit logs:', error);
        setProgramTypeAuditLogs([]);
      } finally {
        setAuditLogsLoading(false);
      }
    };

    fetchAuditLogs();
  }, [programTypeId, hasuraToken]);

  return {
    programTypeAuditLogs,
    auditLogsLoading,
  };
};
